import { render, staticRenderFns } from "./FaqComponents.vue?vue&type=template&id=62095008"
import script from "./FaqComponents.vue?vue&type=script&lang=js"
export * from "./FaqComponents.vue?vue&type=script&lang=js"
import style0 from "./FaqComponents.vue?vue&type=style&index=0&id=62095008&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports